import { Box, Button } from "@mui/material";
import useColors from "../../api/hooks/useColors";
import { ReactComponent as CopyIcon } from "../../icons/icon_files/copy_24.svg";
import SvgToIcon from "../../icons/SvgToIcon";
import CustomToolTip from "../CustomTooltip";

export default function CopyButton({
  handleCopy,
  itemsCount,
  itemName,
  ...props
}) {
  const colors = useColors();

  return (
    <CustomToolTip
      title={
        itemsCount > 0
          ? "Copy to clipboard"
          : `Select entities to copy to clipboard`
      }
      placement="top"
    >
      <Box>
        <Button
          sx={{
            color: colors.text_primary,
            backgroundColor: colors.common_white,
            width: "32px",
            height: "32px",
            minWidth: "auto",
            border: "1px solid " + colors.enabled_stroke,
            textTransform: "unset",
            borderRadius: "8px",
            cursor: "pointer",
            ...props.sx,
          }}
          onClick={handleCopy}
          disabled={itemsCount === 0}
        >
          <SvgToIcon
            IconLogo={CopyIcon}
            width="18px"
            style={{
              color:
                itemsCount > 0
                  ? colors.icon_action_active
                  : colors.action_disabled,
            }}
          />
        </Button>
      </Box>
    </CustomToolTip>
  );
}
